/**
 * A global namespace for `mousemove` event.
 */
const mousemoveEvent = "mousemove";
export default mousemoveEvent;
